import React from 'react';
import styled from 'styled-components';
import { Button } from 'primereact/button';
import { formatDate } from 'util/utils';

type Props = {
  id?: string;
  companyName?: string;
  createdAt?: string;
  onAccept: (id: string) => void;
  onDecline: (id: string, companyName: string) => void;
};

const InviteItem: React.FC<Props> = ({ id, companyName, createdAt, onAccept, onDecline }) => {
  return (
    <Container>
      <CompanyName>{companyName}</CompanyName>

      <InviteDateAndActionsContainer>
        <InviteDate>{formatDate(createdAt)}</InviteDate>
        <Delimiter />
        <DeclineButton
          label="Decline"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onDecline(id!, companyName!);
          }}
        />
        <AcceptButton
          label="Accept"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onAccept(id!);
          }}
        />
      </InviteDateAndActionsContainer>
    </Container>
  );
};

export default InviteItem;

const Container = styled.div`
  width: 100%;
  height: 48px;
  background-color: #fff;
  border-radius: 4px;
  padding: 16px 0 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
`;

const CompanyName = styled.span`
  ${(props) => props.theme.typography.bodyInput}
  color: ${(p) => p.theme.colors.primaryBlack};
`;

const InviteDateAndActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

const InviteDate = styled.span`
  ${(props) => props.theme.typography.bodyInput}
  color: #15151580;
`;

const Delimiter = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${(p) => p.theme.colors.elementsInputBorder};
  margin-left: 12px;
  margin-right: 11px;
`;

const DeclineButton = styled(Button)`
  height: 22px;
  width: 62px;
  border-radius: 2px;

  background-color: ${(p) => p.theme.colors.primaryWhite};
  border-color: ${(p) => p.theme.colors.primaryWhite};
  color: ${(p) => p.theme.colors.primaryOrange};
  font-size: 14px;
  font-weight: 500;
  margin-right: 11px;

  display: flex;
  justify-content: center;

  &&:hover {
    background-color: ${(p) => p.theme.colors.primaryWhite};
    border-color: ${(p) => p.theme.colors.primaryWhite};
    color: ${(p) => p.theme.colors.lightOrange};
  }
`;

const AcceptButton = styled(Button)`
  width: 60px;
  height: 22px;
  border-radius: 2px;

  background-color: ${(p) => p.theme.colors.primaryGreen};
  border-color: ${(p) => p.theme.colors.primaryGreen};
  font-size: 14px;
  font-weight: 500;

  display: flex;
  justify-content: center;

  &&:hover {
    background-color: ${(p) => p.theme.colors.lightGreen};
    border-color: ${(p) => p.theme.colors.lightGreen};
  }

  &:disabled {
    background-color: ${(p) => p.theme.colors.elementsButtonDisabled};
    border-color: ${(p) => p.theme.colors.elementsButtonDisabled};
  }
`;
